import { useState } from "react";
import { Sparkles, Loader2, X } from "lucide-react";
import { adminApi } from "@/lib/adminApi";
import { toast } from "sonner";

export default function AIRecapButton({ project_slug, anchor_date, period, label }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const onClick = async () => {
    setLoading(true);
    try {
      const { data } = await adminApi.aiRecap(project_slug, period, anchor_date);
      setResult(data);
    } catch (e) {
      toast.error(e.message || "AI recap failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={onClick}
        disabled={loading}
        className="inline-flex items-center gap-2 px-3 py-1 text-xs tracking-widest border border-parchment-faint hover:border-four-yellow hover:text-four-yellow transition-colors disabled:opacity-40"
        data-testid={`ai-recap-${period}`}
      >
        {loading ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />}
        {label || `AI ${period.toUpperCase()} RECAP`}
      </button>

      {result && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/70 backdrop-blur-sm"
          onClick={() => setResult(null)}
          data-testid="ai-recap-modal"
        >
          <div
            className="w-full max-w-2xl bg-ink border border-parchment-faint p-8 max-h-[80vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <p className="text-xs tracking-widest opacity-60 text-four-yellow flex items-center gap-2">
                <Sparkles size={12} /> {period.toUpperCase()} RECAP · {result.start} → {result.end}
              </p>
              <button onClick={() => setResult(null)} aria-label="close">
                <X size={16} />
              </button>
            </div>
            <div className="text-sm leading-relaxed whitespace-pre-wrap font-serif">
              {result.text}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
